import { AcademicDetails } from './academic-detail';
import { PersonalInformation } from './personal-information';
import { AdditionalDetails } from './additional-details';


export class UserData {
          academicDetails: AcademicDetails = new AcademicDetails();
          personalInformation: PersonalInformation = new PersonalInformation();
          additionalDetails: AdditionalDetails = new AdditionalDetails();
        //   skillsAndSocial: SkillsAndSocial = new SkillsAndSocial();

        
       }

// academic_details : {
//     class : '',
//     text: '',
//     section: '',
//     first_name: '',
//     last_name: '',
//     admission_no: '',
//     roll_no: ''
//   },
//   personal_information : {
//     profile_img : '',
//     userType : '',
//     user_email : '',
//     birth_date: '',
//     user_contact:'',
//     gender:'',
//     blood_group:''
//   },
//   skills_and_social: {
//     skills : '',
//     facebook_link: '',
//     linkedin_link:''
//   },
//   additional_details: {
//     address : '',
//     zip_code: '',
//     state: '',
//     country:'',
//     mother_name:'',
//     father_name:'',
//     parent_email:'',
//     parent_contact:''
//   }
